import { Box, type BoxProps } from "@hightouch/htui";

import { AD_STUDIO_ICON_PATHS } from "src/ui/icons/ad-studio";

export const Icon = (props: BoxProps) => (
  <Box
    as="svg"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d={AD_STUDIO_ICON_PATHS.frame}
    />
    <path d={AD_STUDIO_ICON_PATHS.sparkle} />
    <path d={AD_STUDIO_ICON_PATHS.sun} />
  </Box>
);
